export default "__VITE_ASSET__f4242bcd__"